const quotations = [
    {
        id: "q-1",
        author: "John Doe, Google Inc.",
        text: "”Hvaing placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum”",
    },
    {
        id: "q-2",
        author: "Unknown Deer, Lviv.",
        text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias, assumenda fugit?",
    },
    {
        id: "q-3",
        author: "Khalil Uddin, MD.",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores incidunt veritatis, corrupti in facilis natus, recusandae totam itaque, quidem laborum cumque! Suscipit eum corporis nemo labore soluta.",
    },
    {
        id: "q-4",
        author: "Rubel Miah.",
        text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio, sequi culpa distinctio eveniet maiores consequuntur libero quas voluptas impedit reprehenderit vel quo temporibus, totam, pariatur necessitatibus quisquam iste nisi saepe?",
    },
    {
        id: "q-5",
        author: "Shamim Mia.",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit suscipit similique a voluptate repellat veniam rem consequuntur dolor!",
    },
]

export default quotations;